<template>
  <v-menu
    :ref="refName"
    v-model="isOpen"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        readonly
        outlined
        v-model="time"
        :label="label"
        class="pointer"
        prepend-inner-icon="mdi-clock-outline"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="isOpen"
      v-model="time"
      format="24hr"
      :min="minTime"
      :allowed-minutes="incrementMinutes"
      full-width
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="isOpen = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="$refs[refName].save(time)">
        OK
      </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    refName: String,
    label: String,
    value: String,
    minTime: String
  },
  data() {
    return {
      isOpen: false,
      time: ''
    }
  },
  mounted() {
    this.syncTime()
  },
  watch: {
    value(n) {
      this.syncTime()
    },
    time(n) {
      this.$emit('update:time', n)
    }
  },
  computed: {},
  methods: {
    incrementMinutes: m => m % 5 === 0,
    syncTime() {
      this.time = this.value
    }
  }
}
</script>

<style lang="sass">
#calendar-master
    .v-text-field.pointer input[readonly]
        cursor: pointer
</style>
